import type { Review } from '../data/reviews';

/**
 * Sort reviews so the ones whose tags overlap with the user's quiz answers
 * (career switcher, returner, burnout, midcareer, etc.) come first.
 * Stable for ties — preserves original list order.
 */
export function rankReviewsByPersona(
  reviews: Review[],
  variables: Record<string, string>,
): Review[] {
  const userTags = new Set<string>();
  if (variables.testTakingPurpose) userTags.add(variables.testTakingPurpose);
  if (variables.employmentStatus === 'searching') userTags.add('careerSwitch');
  if (variables.burnoutExperience === 'true') userTags.add('burnout');
  const currentAge = parseInt(variables.currentAge ?? '0', 10);
  if (currentAge >= 40) userTags.add('midcareer');

  return [...reviews].sort((a, b) => {
    const aMatch = (a.tags ?? []).filter((t) => userTags.has(t)).length;
    const bMatch = (b.tags ?? []).filter((t) => userTags.has(t)).length;
    return bMatch - aMatch;
  });
}
